import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import NoData from "../../atoms/NoData";
import Button from "../../atoms/Button";
import { MdDelete, MdEdit } from "react-icons/md";
import useModal from "../../../hooks/useModal";
import Modal from "../../molecules/Modal";
import ModalEditAccountant from "./ModalEditAccountant";
import { DELETE_ACCOUNTANT, DELETE_USER } from "../../../api/apiAdmin";
import { toast } from "react-toastify";
import ModalConfirm from "../../molecules/ModalConfirm";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { encryptId } from "../../../functions/idEncryptor";
import { getConditionalRowStyles } from "../../../styles/expandedStyles";

const AccountantsTable = ({ data, loading, refetch }) => {
    const [accountant, setAccountant] = useState();
    const { open:open2, close:close2, isOpen:isOpen2 } = useModal();
    const { open:open3, close:close3, isOpen:isOpen3 } = useModal();
    const [expandedRow, setExpandedRow] = useState(null);
    const navigate = useNavigate();

    const handleNavigate = (id) => {
        navigate(`/contador/${encryptId(id)}/empresas`);
    };

    const handleOpenEdit = (accountant) =>{
        setAccountant(accountant);
        open2();
    };

    const handleOpenDelete = (accountant) => {
        setAccountant(accountant);
        open3();
    };

    const handleDelete = async () => {
        try {
            await DELETE_ACCOUNTANT(accountant?.id);
            await DELETE_USER(accountant?.userId);
            toast.success("Eliminado correctamente");
            refetch();
            close3();
        } catch (error) {
            toast.error("Error al eliminar");
            console.error(error);
        }
    };

    const columns = [
        {name: "Nombre", selector: row => row.name},
        {name: "Contacto", cell: row => (
            <div>
                <p> {row.user.email} </p>
                <p> {row.cellphone || "Numero no registrado"} </p>
            </div>
        )},
        {name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-2">
                <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={()=> handleOpenDelete(row)}/>
                <Button text={<FaArrowRight size={22}/>} bgColor="orange" width="w-10" onClick={()=> handleNavigate(row.id)}/>
            </div>
        )},
    ];

    const columnsResponsive = [
        {name: "Contacto", cell: row => (
            <div className="flex flex-col">
                <p> {row.name} </p>
                <p> {row.user.email} </p>
                <p> {row.cellphone || "Numero no registrado"} </p>
            </div>
        )},
    ];

    const ExpandedComponent = ({ data }) => (
        <div className="p-2 w-full flex flex-row justify-around">
            <Button text={<MdEdit size={22} />} bgColor="blue" width="w-10" onClick={() => handleOpenEdit(data)} />
            <Button text={<MdDelete size={22} />} bgColor="red" width="w-10" onClick={() => handleOpenDelete(data)} />
            <Button text={<FaArrowRight size={22}/>} bgColor="orange" width="w-10" onClick={()=> handleNavigate(data.id)}/>
        </div>
    );

    const conditionalRowStyles = getConditionalRowStyles(expandedRow);

    return(
        <div>
            <div className="block md:hidden">
                <DataTable 
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowExpanded={(row) => row?.id === expandedRow?.id}
                    onRowExpandToggled={(expanded, row) => {
                        setExpandedRow(expanded ? row : null);
                    }}
                    conditionalRowStyles={conditionalRowStyles}
                />
            </div>
            <div className="hidden md:block">
                <DataTable 
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                />
            </div>
            {isOpen2 && 
                <Modal title="Editar contador" onClose={close2}>
                    <ModalEditAccountant onClose={close2} refetch={refetch} accountant={accountant} />
                </Modal>
            }
            {isOpen3 && 
                <ModalConfirm onClose={close3} onConfirm={handleDelete} eliminacion />
            }
        </div>
    );
};

export default AccountantsTable;